import { handleActions } from "redux-actions";
import {
  CATEGORY_DETAILS_LOADED,
  CATEGORY_FAQS_LOADED,
  CATEGORY_LOADED,
  CURATED_CATEGORY_TREATMENTS_LOADED,
  SET_CATEGORY_ERROR,
  CLEAR_CATEGORY_DETAILS,
  CLEAR_CATEGORY_ERROR,
  CLEAR_CURATED_CATEGORY_TREATMENTS,
  SIBLING_CATEGORIES_LOADED,
  RELATED_CATEGORIES_LOADED
} from "./constants";
import { mapBreadcrumbs } from "./mapBreadcrumbs";

export {
  setCategoryError,
  clearCategoryError,
  clearCuratedCategoryTreatments
} from "./actions";
export {
  getCategoryDetails,
  getCategoryId,
  getCategoryGender,
  getCategoryTitle,
  getCategoryBreadcrumbs,
  getCategoryError,
  getCategoryHeaderDescription,
  getCategoryIsBrand,
  getCategoryIsEarlyAccess,
  getCategoryFaqs,
  getIsEarlyAccessCategoryComingSoon,
  getCategoryTreatments
} from "./selectors";

const initialState = {
  breadcrumbs: []
};

export default handleActions(
  {
    [CATEGORY_DETAILS_LOADED]: (state, { error, payload }) => {
      if (error) {
        return { ...state };
      }

      return {
        ...state,
        details: payload
      };
    },

    [CATEGORY_FAQS_LOADED]: (state, { error, payload }) => {
      if (error) {
        return { ...state };
      }

      return {
        ...state,
        faqs: payload
      };
    },

    [CATEGORY_LOADED]: (state, { error, payload }) => {
      if (error) {
        return { ...state };
      }

      return {
        ...state,
        isBrand: payload.isBrand,
        gender: payload.gender,
        type: payload.type,
        childLinks: payload.categories,
        breadcrumbs: mapBreadcrumbs(payload.breadcrumb),
        isCurated: payload.isCurated,
        loyaltyBenefitType: payload.loyaltyBenefitType
      };
    },

    [SIBLING_CATEGORIES_LOADED]: (state, { payload }) => ({
      ...state,
      siblingCategories: payload || []
    }),

    [RELATED_CATEGORIES_LOADED]: (state, { payload }) => ({
      ...state,
      relatedCategories: payload || []
    }),

    [CURATED_CATEGORY_TREATMENTS_LOADED]: (state, { payload }) => ({
      ...state,
      treatments: payload
    }),

    [CLEAR_CATEGORY_DETAILS]: state => ({
      ...state,
      details: {}
    }),

    [SET_CATEGORY_ERROR]: (state, action) => {
      const { status, message = "" } = action.payload;

      return {
        ...state,
        error: {
          status,
          isTimeout: message.includes("timeout")
        }
      };
    },

    [CLEAR_CATEGORY_ERROR]: state => ({
      ...state,
      error: null
    }),

    [CLEAR_CURATED_CATEGORY_TREATMENTS]: state => ({
      ...state,
      treatments: null
    })
  },
  initialState
);
